<template lang="pug">
div
  v-container(fluid).pa-0
    v-row(justify='center' align='center')
      v-col(xs=12 sm=6 md=6 xl=6)
        v-row.justify-center
          p.text-center.display-1.azul--text.font-weight-bold.my-2.mx-12.icono-international.icono-grande( style='position: relative' v-html='Lineas_Comerciales.cuerpo.titulo').pt-7.pl-7
          p.text-center.headline.font-weight-thin.my-2.mx-12.azul--text( style='position: relative' v-html='Lineas_Comerciales.cuerpo.sub').mb-10  
  v-container#contenido-lineas-comerciales 
    v-row
      v-col
        Rutas
    v-row
      v-col(  md=4  v-if='!producto').pt-0
        Menu
      v-col( cols=12 :md='producto ? 12 : 8').pt-0
        Ver_producto( v-if='producto')
        Ver_categorias( v-else-if='categoria')
        Ver_busqueda( v-else-if='busqueda')

        Ver_filtro_por_linea( v-else-if='linea_comercial')
        Ver_lineas_de_productos( v-else )
    v-row
      v-col
        Marcas_Aliadas
</template>
<script>
export default {
  computed: {
    Lineas_Comerciales() {
      return this.$contenido.Lineas_Comerciales || {cuerpo: {}}
    },
    linea_comercial(){
      return this.$route.params.linea_comercial
    },
    categoria(){
      return this.$route.params.categoria
    },
    producto(){
      return this.$route.params.producto
    },
     busqueda(){
      return this.$route.params.busqueda
    }
  },
  components:{
    Rutas:()=> import('./componentes/rutas'),
    Menu: ()=>import('./componentes/Menu'),
    Marcas_Aliadas:()=> import('./componentes/marcas_aliadas'),
    Ver_lineas_de_productos: ()=>import('./componentes/Ver_lineas_de_productos'),
    Ver_categorias: ()=>import('./componentes/Ver_categorías'),
    Ver_filtro_por_linea: ()=>import('./componentes/Ver_filtro_por_linea'),

    Ver_producto: ()=>import('./componentes/Ver_producto'),
    Ver_busqueda: ()=>import('./componentes/Ver_busqueda'),


  }
}
</script>